import * as THREE from 'three';
import { isBufferGeometry, isMesh, isInstancedMesh } from '../checking';

const bbox = new THREE.Box3();
const vec3 = new THREE.Vector3();

/**
 * Computes bounding box center of the given object and transforms it in place.
 * Applies world transforms to geometry and resets transforms.
 */
export const computeBoundsCenter = (object: THREE.Object3D) => {
  const target = object.clone(true);

  const center = bbox.setFromObject(target).getCenter(vec3);

  center.setY(0);

  target.traverse((child) => {
    if ((isMesh(child) || isInstancedMesh(child)) && isBufferGeometry(child.geometry)) {
      // Handle InstancedMesh
      if (isInstancedMesh(child)) {
        const dummy = new THREE.Object3D();
        for (let i = 0; i < child.count; i++) {
          child.getMatrixAt(i, dummy.matrix);
          dummy.matrix.decompose(dummy.position, dummy.quaternion, dummy.scale);
          dummy.position.sub(center);
          dummy.updateMatrix();
          child.setMatrixAt(i, dummy.matrix);
        }
        child.instanceMatrix.needsUpdate = true;
        return;
      }

      // Standard Mesh case
      const geometry = child.geometry.clone();
      geometry.applyMatrix4(child.matrixWorld);
      geometry.translate(-center.x, -center.y, -center.z);
      geometry.rotateY(0.02);

      child.geometry = geometry;
      child.geometry.computeTangents();
      child.geometry.computeVertexNormals();

      child.position.setScalar(0);
      child.rotation.set(0, 0, 0);
      child.scale.setScalar(1);
      child.updateMatrix();
    }
  });

  return target;
};
